module.exports = __webpack_public_path__ + "static/media/restart.4cf97ccd.svg";